import { LicenseManager } from 'ag-grid-enterprise';

export const setAgGridLicense = () => {
  LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE_KEY);
};
